module.exports = __webpack_public_path__ + "static/media/forgotten-fatherland-ben-macintyre.2b9a41b5.jpg";